<template>
  <div class="request-button">
    <button
      :disabled="requested || loading"
      @click="handleRequest"
    >
      {{ requested ? 'Requested' : loading ? 'Requesting...' : 'Request' }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'RequestButton',
  props: {
    trackId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      requested: false
    }
  },
  methods: {
    async handleRequest () {
      if (this.requested || this.loading) return
      this.loading = true

      try {
        const res = await fetch(`https://api.organlive.com/request/${this.trackId}`)
        const html = await res.text()
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')
        const errorText = doc.querySelector('h2.error')?.textContent

        if (errorText) {
          alert(errorText)
        } else {
          this.requested = true
        }
      } catch (err) {
        alert('Network error sending request.')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
